// removed by extract-text-webpack-plugin
module.exports = {"container":"a7_g"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/EventReviewPage/styles.module.css
// module id = 1323
// module chunks = 27